import { useMutation } from '@tanstack/react-query';
import { get } from 'app/shared/utils/fetchr';

interface CacheAlertPayload {
  alert_id: number;
}

export const useCacheAlert = () =>
  useMutation({
    mutationFn: (payload: CacheAlertPayload) =>
      get(`/alerts/cached/${payload.alert_id}`),
  });
